import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppStorageService } from '@shared/storage/app-storage.service';

@Component({
  selector: 'app-certification-validation',
  templateUrl: './certification-validation.page.html',
  styleUrls: ['./certification-validation.page.scss'],
})
export class CertificationValidationPage implements OnInit {
  
  @Input() missingFields: string;
  isLoaded: boolean = false;

  constructor(
    storageService: AppStorageService,
    private modalController: ModalController
  ) {
    storageService.IsLoadedSubject.subscribe(x => { 
      if (!this.isLoaded && x) {
        this.isLoaded = true;
      }
    });
  }

  ngOnInit() {
  }

  ok(didConfirm: boolean) {
    this.modalController.dismiss({
      didConfirm: didConfirm
    });
  }

}
